export default __webpack_public_path__ + "static/media/expl-nn_11_EN.3a82c68e.png";